import React from 'react';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';

import { getVideoUrl } from 'lib/getVideoUrl';
import Carousel from './Carousel';

const PopUpTour: React.FC<{ tours?: string[] | string | null }> = ({
  tours,
}) => {
  const more639 = useMediaQuery('(min-width: 639px)');

  return (
    <div
      className={classNames(
        'md:pr-[35px] md:pl-[36px] overflow-y-auto pb-60 md:pb-60 lg:pb-0 flex justify-center h-full',
        {
          'pl-[11px] pr-[12px]': !more639,
          'pl-[24px] pr-[25px]': !!more639,
        }
      )}
    >
      <div className="relative video-popup w-full">
        {Array.isArray(tours) ? (
          <Carousel
            emblaOptions={{
              loop: true,
            }}
            fullWidthSlides={true}
            showArrows={true}
          >
            {tours.map((url) => {
              let videoUrl = getVideoUrl(url);
              videoUrl.searchParams.append('enablejsapi', '1');
              return (
                <div
                  className="flex justify-center w-full h-screen-tour-video"
                  key={url}
                >
                  <iframe
                    className="w-full h-full"
                    src={videoUrl.toString()}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              );
            })}
          </Carousel>
        ) : tours ? (
          <div className="w-full h-full aspect-video">
            <iframe
              src={
                tours.includes('watch')
                  ? tours.replace('watch?v=', 'embed/')
                  : tours.includes('youtu.be')
                  ? tours.replace('youtu.be', 'www.youtube.com/embed/')
                  : tours.includes('dropbox')
                  ? tours.replace('dl=0', 'raw=1')
                  : tours
              }
              className="w-full h-full"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PopUpTour;
